<template lang="pug">
  .SearchSide(:class="(deployState && ' deploy ') + (isSearchOpened && ' active ')")
    transition(name="fade")
      SwitcherIcon( v-if="isSampled" :active="searchListType" @toggle="toggleListType")
    .SearchSide_scroller
      transition(name="fade")
        span.switcherBtn(@click="() => sampleSwitch()" v-if="searchListType") {{isSampled ? $t('search.switcher.drawers') : $t('search.switcher.samples')}}
      transition(name="fade")
        SearchListTypes(label="Type", name="type")
      transition(name="fade")
        SearchListStratigraphic(label="Stratigraphic", name="stratigraphic_age_limits", v-if="hasStratigraphicAgeLimits")
      .SearchSide_attributesGroups
        SearchAttributesGroup(v-for="(a, index) in attributes", :label="a.label", :name="a.name", :group="a", :key="index")
        SearchAttributesGroup(:label="attributesOre.label", :name="attributesOre.name", :group="attributesOre", :key="attributes.length + 1", v-if="isOreActive")
    SearchSideFooter(:deployState="deployState", @deployTrigger="onDeployTrigger")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import SearchAttributesGroup from '@/components/SearchAttributesGroup'
import SearchListStratigraphic from '@/components/SearchListStratigraphic'
import SearchListTypes from '@/components/SearchListTypes'
import SearchSideFooter from '@/components/SearchSideFooter'
import SearchTreeMenu from '@/components/SearchTreeMenu'
import SwitcherIcon from '@/components/common/SwitcherIcon'
import { Component } from 'vue-instantsearch'
import store from '@/store'

export default {
  mixins: [ Component ],
  data () {
    return {
      deployState: false,
      attributes: [
        { label: this.$t('search.attributes.drawer_collection'), name: 'drawer_collection' },
        { label: this.$t('search.attributes.drawer_localisation'), name: 'drawer_localisation' },
        { label: this.$t('search.attributes.stratigraphic_age_limits'), name: 'stratigraphic_age_limits' },
        { label: this.$t('search.attributes.stratigraphic_age'), name: 'stratigraphic_age', tree: ['stratigraphic_age.lvl0', 'stratigraphic_age.lvl1', 'stratigraphic_age.lvl2', 'stratigraphic_age.lvl3'] },
        { label: this.$t('search.attributes.phylogenetic_group'), name: 'phylogenetic_group', tree: ['phylogenetic_group.lvl0', 'phylogenetic_group.lvl1', 'phylogenetic_group.lvl2'] },
        { label: this.$t('search.attributes.fossil_environment'), name: 'fossil_environment', tree: ['fossil_environment.lvl0', 'fossil_environment.lvl1'] },
        { label: this.$t('search.attributes.rock_family'), name: 'rock_family', tree: ['rock_family.lvl0', 'rock_family.lvl1'] },
        { label: this.$t('search.attributes.rock_environment'), name: 'rock_environment', tree: ['rock_environment.lvl0', 'rock_environment.lvl1'] },
        { label: this.$t('search.attributes.mineral_classification'), name: 'mineral_classification', tree: ['mineral_classification.lvl0', 'mineral_classification.lvl1'] },
        { label: this.$t('search.attributes.country'), name: 'country' },
        { label: this.$t('search.attributes.collection'), name: 'collection' },
        { label: this.$t('search.attributes.mineral_chemical_composition'), name: 'mineral_chemical_composition' },
        { label: this.$t('search.attributes.shape'), name: 'shape' },
        { label: this.$t('search.attributes.mineral_mohs_hardness'), name: 'mineral_mohs_hardness' },
        { label: this.$t('search.attributes.mineral_crystalline_system'), name: 'mineral_crystalline_system' },
        { label: this.$t('search.attributes.mineral_scarcity'), name: 'mineral_scarcity' },
        { label: this.$t('search.attributes.transparency'), name: 'transparency' },
        { label: this.$t('search.attributes.color'), name: 'color' },
        { label: this.$t('search.attributes.grain'), name: 'grain' }
      ],
      attributesOre: { label: this.$t('search.attributes.ore_composition_name'), name: 'ore_composition_name' },
      isOreActive: false
    }
  },
  components: { SearchTreeMenu, SearchAttributesGroup, SearchListStratigraphic, SearchListTypes, SearchSideFooter, SwitcherIcon },
  updated () {
    const objectRefinement = this.searchStore.activeRefinements

    if (Object.keys(objectRefinement).find(key => objectRefinement[key].name === 'ore')) {
      this.isOreActive = true
    } else {
      this.isOreActive = false
      this.searchStore.clearRefinements('ore_composition_name')
    }
  },
  computed: {
    ...mapGetters(['isSearchOpened', 'searchListType', 'isSampled']),

    hasStratigraphicAgeLimits () {
      return this.searchStore && this.searchStore.results.every(r => r.stratigraphic_age_limits) && (this.searchStore.results.length > 0)
    }
  },
  watch: {
    isSearchOpened () {
      if (!this.isSearchOpened && !this.isSampled) {
        this.sampleSwitch()
      }
    }
  },
  methods: {
    ...mapActions(['setIsSample']),
    onDeployTrigger (state) {
      this.deployState = state
    },
    toggleListType () {
      store.dispatch('setSearchListType', !this.searchListType)
    },
    sampleSwitch () {
      this.searchStore.stop()

      if (this.searchStore.query.length > 0) {
        this.searchStore.query = ''
      }
      if (this.searchStore.activeRefinements.length > 0) {
        this.searchStore.activeRefinements.forEach(ref => {
          if (ref.attributeName !== 'lat' && ref.attributeName !== 'lng') {
            this.searchStore.clearRefinements(ref.attributeName)
          }
        })
      }

      this.searchStore.queryParameters = { filters: `entity_id:${this.isSampled ? 'drawer' : 'sample'}` }

      store.dispatch('setIsSample', !this.isSampled)

      this.searchStore.start()
      this.searchStore.refresh()
    }
  }
}

</script>

<style lang="stylus" scoped>

.SearchSide
  z-index 10
  box-sizing: border-box
  position: absolute
  top 0
  right 0
  bottom 0
  width calc(35% - 24px)
  transform translateX(100%)
  background-color $grey-2
  background-image url('/img/backgrounds/grey2_grain_background.jpg')
  background-position 50%
  background-repeat repeat
  padding: 110px 0
  transition: all 1s $ease

  .switcherBtn
    padding 4px 25px
    margin 20px auto
    height 40px
    text-transform uppercase
    color $beige
    width fit-content
    display block
    line-height 40px
    text-decoration none
    border 1px solid $beige
    border-radius 50px
    cursor pointer
    white-space: nowrap;
    overflow hidden
    position relative
    backface-visibility: hidden;
    transition: border-color 0.3s, color 0.3s, transform 1s, opacity 0.8s ;
    transition-timing-function: cubic-bezier(0.23, 1, 0.32, 1);

    &:before
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      width: 150%;
      height: 100%;
      background: white;
      z-index: -1;
      transform: rotate3d(0, 0, 1, -45deg) translate3d(0, 3em, 0);
      transform-origin: 100% 0%;
      transition: transform 0.3s, opacity 0.3s, background-color 0.3s;

    @media $mq_s_only
      font-size 14px
      white-space: normal;
      padding 10px 25px

    &:hover, &.hover
      border-color transparent
      color $black
      transform translateZ(0) perspective(1px)

      &:before
        opacity: 1;
        background-color: $beige;
        transform: rotate3d(0, 0, 1, 0deg);
        transition-timing-function: cubic-bezier(0.23, 1, 0.32, 1);

    &:focus
      transform translateZ(0) perspective(1px)
      opacity 0.5

  &.active
    transform translateX(0%)

  @media $mq_s_only
    width calc(100% - 40px)
    height 0vh
    bottom unset
    padding 80px 0 60px 0

    &.deploy
      height 100vh

  .SwitcherIcon
    position relative
    width 70px
    margin 20px auto 20px

  &_scroller
    position relative
    box-sizing: border-box
    padding 0px 40px
    max-height calc(100% - 80px) // 80px = height of SearchSideFooter
    overflow-y auto // allow scroll
    -webkit-overflow-scrolling touch // smooth scroll

    @media $mq_m_only

      padding 0px 40px 20px 40px

    @media $mq_s_only

      padding 0px 20px

  &_attributesGroups
    margin: 20px 0

</style>
